import P from '../../pages';
import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import RegisterForm from './RegisterForm';
import { setPage } from '../../actions'

const Register = ({
  page,
  onRegisterUser=f=>f,
  onGoBack,
  intl,
  content,
  marketing_referrers,
  marital_statuses,
  country_code,
  environment,
  transaction_email,
  territory_code,
  generateDetailsEnabled,
  showGenderField,
  requiredFields,
  criticalContracts,
  address,
  addressValidations,
  recaptchaSiteId,
  firebaseEnabled,
  redirectToFirebaseLogin
}) => {

  const { formatMessage } = intl;
  const thisPage = P.REGISTER_PAGE;

  useLayoutEffect(() => {
    if (!firebaseEnabled) return;

    redirectToFirebaseLogin()
  }, [])

  return (
    <div>
      <Redirector this_page={thisPage} page={page}/>
      <FormHeader title={content.pages.register.title}/>
      <RegisterForm
        onRegisterUser={onRegisterUser}
        onGoBack={onGoBack}
        intl={intl}
        marketing_referrers={marketing_referrers}
        marital_statuses={marital_statuses}
        country_code={country_code}
        content={content}
        environment={environment}
        transaction_email={transaction_email}
        territory_code={territory_code}
        generateDetailsEnabled={generateDetailsEnabled}
        showGenderField={showGenderField}
        criticalContracts={criticalContracts}
        requiredFields={requiredFields}
        address={address}
        addressValidations={addressValidations}
        recaptchaSiteId={recaptchaSiteId}
      />
    </div>
  );
};

Register.propTypes = {
  onRegisterUser: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  marketing_referrers: PropTypes.array,
  country_code: PropTypes.string,
  environment: PropTypes.string
};

export default injectIntl(Register);
